export default {
  title: 'Enregistrer les coordonnées et le moyen de paiement',
  form: {
    remember_me: {
      label: 'Créez un compte pour un paiement plus rapide lors de vos prochaines commandes.',
    },
  },
};
